import { SxProps } from "@mui/material";

export const sxPagination: SxProps = {
    width: 'auto',
    height: '32px',
    background: 'unset',
    color: 'unset',
    fontSize: 'unset',
    fontStyle: 'unset',
    fontWeight: 'unset',
    lineHeight: 'unset',
    position: 'unset',
    button: {
        fontFamily: 'UnimedSans-Bold',
        backgroundColor: '#EEE',
        color: '#5F5F5F'
    }
}

export const sxStartAdornment: SxProps = {
    fontFamily: 'Unimed-Sans',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '21px',
}

export const sxAtestadosCard: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    padding: '12px 32px ',
    width: 'auto'
}

export const sxTextField: SxProps = {
    input: {
        fontFamily: 'Unimed-Sans',
        color: '#383838',
        fontSize: '14px',
    }
}

export const sxTable: SxProps = {
    borderRadius: '10px',
    width: '90%'
}

export const sxButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    padding: '12px 32px ',
    '@media (max-width: 899px)': {
        width: '100%',
        maxWidth: 'unset'
    },
}

export const sxOutlinedButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    border: '2px solid var(--Primary-01-Medium, #00995D)',
    padding: '12px 32px '
}


export const sxRadio: SxProps = {
    '.MuiFormControlLabel-label': {
        fontSize: '14px'
    }
}

export const sxCheckbox: SxProps = {
    '.MuiFormControlLabel-label': {
        fontSize: '14px',
        color: '#4C4C4C'
    }
}

export const sxModal: SxProps = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '578px',
    width: '85%',
    bgcolor: '#fff',
    borderRadius: '16px',
    border: 'none',
    boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
    padding: '32px',
    gap: '24px',
}

export const sxLabel: SxProps = {
    fontFamily: 'Unimed-Sans',
    color: '#383838',
    fontWeight: 600,
}

export const sxInput: SxProps = {
    fontFamily: 'Unimed-Sans',
    color: '#383838',
    fontWeight: 400,
    fontSize: '14px'
}

export const sxError: SxProps = {
    color: '#D84141',
    fontSize: '12px'
}

export const sxButtonText: SxProps = {
    textDecoration: 'underline',
    textTransform: 'none',
    fontFamily: 'Unimed-Sans',
    fontWeight: 600,
    padding: 0,
    '&:hover': {
        color: '#164029',
    }
}

export const sxValidationMessage: SxProps = {
    fontFamily: 'Unimed-Sans',
    color: '#D84141',
    fontSize: 12
}

export const sxButtonTextBack: SxProps = {
    textDecoration: 'underline',
    textTransform: 'none',
    fontFamily: 'Unimed-Sans',
    fontWeight: 600,
    padding: 0,
    '&:hover': {
        color: '#164029',
    },
    color: '#383838'
}

export const sxLabeledOutlinedInput: SxProps = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: 'inherit',
    '@media (max-width: 768px)': {
        width: '100%',
        maxWidth: 'unset'
    },
    maxWidth: '466px'
}
export const sxFindDoctorBox: SxProps = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '15px',
    alignItems: 'flex-end',
    width: '100%'
}
